import {NgModule} from '@angular/core'
import {AsyncPipe, NgOptimizedImage, NgTemplateOutlet, UpperCasePipe} from '@angular/common'
import {ArticlePageComponent} from './article-page/article-page.component'
import {ArticleLanguageUnavailablePageComponent} from './article-language-unavailable-page/article-language-unavailable-page.component'
import {RichTextModule} from '../../../shared/components/rich-text/rich-text.module'
import {ArticleOverviewPageComponent} from './article-overview-page/article-overview-page.component'
import {ArticlePreviewComponent} from './article-preview/article-preview.component'
import {ArticleResolver} from './article-page/article.resolver'
import {ArticleLanguageUnavailableResolver} from './article-language-unavailable-page/article-language-unavailable.resolver'
import {TopicOverviewPageComponent} from './topic-overview-page/topic-overview-page.component'
import {TopicOverviewResolver} from './topic-overview-page/topic-overview.resolver'
import {AuthorsModule} from '../../../shared/components/content/authors/authors.module'
import {ChipComponent} from '../../../craft/chip/chip.component'
import {SpinnerComponent} from '../../../craft/spinner/spinner.component'
import {ButtonModule} from '../../../craft/button/button.module'
import {BreadcrumbsModule} from '../../../craft/breadcrumbs/breadcrumbs.module'
import {ArticleContentService} from '../../../core/content/services/article-content.service'
import {DirectivesModule} from '../../../shared/directives/directives.module'
import {SearchbarComponent} from '../../../craft/searchbar/searchbar.component'
import {SortingModule} from '../../../craft/sorting/sorting.module'
import {HolyGrailGridModule} from '../../../craft/holy-grail-grid/holy-grail-grid.module'
import {HeroCoverComponent} from '../../../craft/hero-cover/hero-cover.component'
import {HeroCoverTitleComponent} from '../../../shared/components/hero-cover/hero-cover-title/hero-cover-title.component'
import {FilterModule} from '../../../craft/filter/filter.module'
import {MessageModule} from '../../../craft/message/message.module'
import {SidenavTopicsComponent} from './article-overview-page/sidenav-topics/sidenav-topics.component'
import {SidenavArticlesComponent} from './topic-overview-page/sidenav-articles/sidenav-articles.component'
import {NewStickyFooterComponent} from '../../../shared/components/new-sticky-footer/new-sticky-footer.component'
import {NewStickyFooterContentComponent} from '../../../shared/components/new-sticky-footer/new-sticky-footer-content/new-sticky-footer-content.component'
import {BuildigoValueCheckmarksComponent} from '../../../shared/components/buildigo-value-checkmarks/buildigo-value-checkmarks.component'
import {ArticleInlineTableOfContentComponent} from './article-page/article-inline-table-of-content/article-inline-table-of-content.component'
import {ShareButtonComponent} from '../../../shared/components/share-button/share-button.component'
import {ArticlePageSidenavComponent} from './article-page/article-page-sidenav/article-page-sidenav.component'
import {TableOfContentModule} from '../../../shared/components/table-of-content/table-of-content.module'
import {TranslocoDirective} from '@ngneat/transloco'
import {RouterLink} from '@angular/router'
import {HeroCoverPlotComponent} from '../../../craft/hero-cover/hero-cover-plot/hero-cover-plot.component'
import {ArticleRoutingModule} from './article-routing.module'
import {HolyGrailStickyWrapperComponent} from '../../../craft/holy-grail-grid/holy-grail-grid-col-left/holy-grail-sticky-wrapper.component'

@NgModule({
  providers: [ArticleResolver, ArticleLanguageUnavailableResolver, ArticleContentService, TopicOverviewResolver],
  declarations: [
    ArticlePageComponent,
    ArticleOverviewPageComponent,
    ArticleLanguageUnavailablePageComponent,
    TopicOverviewPageComponent,
    ArticleInlineTableOfContentComponent,
  ],
  imports: [
    AsyncPipe,
    TranslocoDirective,
    HolyGrailGridModule,
    ArticlePageSidenavComponent,
    TableOfContentModule,
    BreadcrumbsModule,
    ChipComponent,
    AuthorsModule,
    ShareButtonComponent,
    NgOptimizedImage,
    RichTextModule,
    NewStickyFooterComponent,
    NewStickyFooterContentComponent,
    BuildigoValueCheckmarksComponent,
    SidenavTopicsComponent,
    SearchbarComponent,
    FilterModule,
    ArticlePreviewComponent,
    ButtonModule,
    SpinnerComponent,
    RouterLink,
    UpperCasePipe,
    DirectivesModule,
    SidenavArticlesComponent,
    HeroCoverComponent,
    HeroCoverTitleComponent,
    SortingModule,
    MessageModule,
    NgTemplateOutlet,
    HeroCoverPlotComponent,
    ArticleRoutingModule,
    HolyGrailStickyWrapperComponent,
  ],
})
export default class ArticleModule {}
